import * as FullStory from '@fullstory/browser'

let initialized = false
const queue = []

export function fullstoryMarkInitialized() {
    initialized = true
    while (queue.length > 0) {
        const fn = queue.shift()
        try {
            fn()
        } catch (e) {
            console.error('FullStory queued call failed', e)
        }
    }
}

function enqueue(fn) {
    if (initialized) {
        try {
            fn()
        } catch (e) {
            console.error('FullStory call failed', e)
        }
        return
    }
    queue.push(fn)
}

// See https://help.fullstory.com/hc/en-us/articles/360020828113
export async function fullstoryIdentify(userSessionData) {
    if (userSessionData?.is_logged_in) {
        enqueue(() =>
            FullStory.identify(`${userSessionData.user_id}`, {
                displayName: userSessionData.full_name ?? null,
                email: userSessionData.username,
            })
        )
    }
}

// See https://help.fullstory.com/hc/en-us/articles/360020623294-FS-setUserVars-API-Capturing-custom-user-properties
export async function fullstorySetUserVars(userVars) {
    enqueue(() => FullStory.setUserVars(userVars))
}

// See https://developer.fullstory.com/browser/v1/custom-events/
export function fullstoryEvent(eventName, eventProperties) {
    enqueue(() => FullStory.event(eventName, eventProperties ?? {}))
}
